export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_08.0436a6b7.jpg";